import { useCallback, useEffect, useState } from "react";
import { ScrollView, View, Text, ActivityIndicator, TouchableOpacity } from "react-native";
import * as FileSystem from 'expo-file-system';
import { ArticleJSON } from "@/services/Datatypes";
import { findArticleByJobId } from "@/services/readLocalJsonFile";
import { router, useLocalSearchParams } from "expo-router";
import { ModalSlideshow } from "@/components/ModalSlideshow";
import { decode } from 'html-entities';
import { useBoundStore } from '@/services/zustand/Store';


export default function ModalScreen() {
    const { articleID, pageNumber, JSONPath } = useLocalSearchParams()
    const currentMagazine = useBoundStore(useCallback((state) => state.magazine, []));
    const [loading, setLoading] = useState(false);
    const [articleData, setArticleData] = useState<ArticleJSON>();

    useEffect(() => {
        setLoading(true);
        const prepareArticle = async () => {
            if (typeof JSONPath === 'string' && typeof articleID === 'string') {
                try {
                    let foundArticle: ArticleJSON | null = await findArticleByJobId(JSONPath, articleID);
                    if (foundArticle !== null) {
                        setArticleData(foundArticle);
                    }
                } catch (error) {
                    console.error('Error reading article json:', error);
                } finally {
                    setLoading(false);
                }
            }
        }
        prepareArticle();
    }, [articleID]);

    return (
        <ScrollView style={{ flex: 1 }}>
            {loading ? (
                <ActivityIndicator size="large" color="#0000ff" />
            ) : (
                <>
                    {articleID && articleData && currentMagazine ? (
                        <>
                            {articleData.images && Array.isArray(articleData.images) ? (
                                <>
                                    {/* <ModalSlideshow images={[`${FileSystem.documentDirectory}/epaper/${currentMagazine.date}/${currentMagazine.edition}/${pageNumber}/${articleData.head.verwaltungsdaten.orgbild["#text"]}`]} /> */}
                                    <ModalSlideshow images={articleData.images.map(
                                        (img) => `${FileSystem.documentDirectory}/epaper/${currentMagazine.date}/${currentMagazine.edition}/${pageNumber}/${img}`)} />
                                </>
                            ) : null}
                            {articleData.headline !== "" ? (
                                <Text style={{ fontSize: 24, fontFamily: 'Roboto', fontWeight: 'bold', color: '#000', margin: 10 }}>{decode(articleData.headline)}</Text>
                            ) : null}
                            {articleData.kicker !== "" ? (
                                <Text style={{ fontSize: 18, fontFamily: 'Roboto', fontWeight: 'normal', color: '#000', margin: 10 }}>{decode(articleData.kicker)}</Text>
                            ) : null}
                            {articleData.autor !== "" ? (
                                <Text style={{ fontSize: 14, fontFamily: 'Roboto', fontWeight: 'normal', color: '#555', margin: 5 }}>Von {decode(articleData.autor)}</Text>
                            ) : null}
                            {Array.isArray(articleData.content) ? (
                                <>
                                    {articleData.content.map((text, index) => (
                                        <View key={index} style={{ marginBottom: 15 }}>
                                            <Text
                                                style={{
                                                    color: '#000',
                                                    fontFamily: 'Roboto',
                                                    textAlign: 'left',
                                                    lineHeight: 28,
                                                    fontSize: 18,
                                                    width: '95%',
                                                    alignSelf: 'center',
                                                }}>
                                                {decode(text)}
                                            </Text>
                                        </View>
                                    ))}
                                </>
                            ) :
                                <View style={{ marginBottom: 15 }}>
                                    <Text
                                        style={{
                                            color: '#666',
                                            fontFamily: 'Roboto',
                                            textAlign: 'left',
                                            lineHeight: 28,
                                            fontSize: 18,
                                            width: '95%',
                                            alignSelf: 'center',
                                        }}>
                                        {decode(articleData.content)}
                                    </Text>
                                </View>
                            }
                            <TouchableOpacity onPress={() => router.back()}
                                style={{
                                    width: '80%',
                                    padding: 20,
                                    backgroundColor: '#069',
                                    borderRadius: 8,
                                    alignSelf: 'center',
                                    alignItems: 'center',
                                    margin: 30,
                                }}>
                                <Text style={{ color: '#fff' }}>Schließen</Text>
                            </TouchableOpacity>
                        </>
                    ) : (
                        <>
                            <Text style={{ color: '#666' }}>Article not found.</Text>
                            <TouchableOpacity onPress={() => router.back()}
                                style={{
                                    width: '80%',
                                    padding: 20,
                                    backgroundColor: '#069',
                                    borderRadius: 8,
                                    alignSelf: 'center',
                                    alignItems: 'center',
                                    margin: 30,
                                }}>
                                <Text style={{ color: '#fff' }}>Schließen</Text>
                            </TouchableOpacity>
                        </>
                    )}
                </>
            )
            }
        </ScrollView>
    );
}